import { useState, useEffect } from 'react'
import { get } from 'aws-amplify/api'
import { removeSeveritylessAlerts } from 'helpers/alerts'
import { AlertsHistory } from 'types/Alert'
import { getCachedAuthSession } from 'services/authSessionCache'

const useServerlessAlertHistory = (
  deviceId: string,
  startTime: string,
  endTime: string,
  timeZone: string
) => {
  const [alertsHistory, setAlertsHistory] = useState<AlertsHistory | null>(null)
  const [isAlertsHistoryLoaded, setIsAlertsHistoryLoaded] = useState(false)

  useEffect(() => {
    (async () => {
      setIsAlertsHistoryLoaded(false)
      const session = await getCachedAuthSession()

      try {
        const res = await get({
          apiName: 'dwaApi',
          path: `/alert-history/${deviceId}?startDate=${startTime}&endDate=${endTime}&timezone=${timeZone}`,
          options: {
            headers: { 'Authorization': session?.tokens?.idToken?.toString() || '' }
          }
        }).response

        const alertHistory = await res.body.json() as unknown as AlertsHistory
        if (alertHistory?.historyDetails) {
          alertHistory.historyDetails = removeSeveritylessAlerts(alertHistory.historyDetails)
        }
        setAlertsHistory(alertHistory)
      } catch (_error) { // eslint-disable-line @typescript-eslint/no-unused-vars
        setAlertsHistory(null)
      } finally {
        setIsAlertsHistoryLoaded(true)
      }
    })()
  }, [deviceId, startTime, endTime, timeZone])

  return {
    alertsHistory,
    isAlertsHistoryLoaded
  }
}

export default useServerlessAlertHistory
